import React, { useState } from "react"
import styled from '~/ui/styled'
import { observer } from "mobx-react-lite"
import { Text, BetweenFlex, ColumnFlex } from "~components/El"
import { ModalProps } from "./types"
import { useStores } from "~models"
import { alertSuccess } from "~utils/alert"
import { Event, EventNames, UserUpdateData, FLAG_ACK, UserGender } from "~proto"

const CurModal = styled.Modal``
const CurModalBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width:500px;
  background-color: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
`
const CurViewButton = styled.button`
  width: 100%;
  padding: 13px 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font: inherit;
`

const Modal: React.FC<ModalProps> = ({ visible, showVisible }) => {
  const { eventStore, userStore } = useStores()
  const [sex, setSex] = useState<UserGender>(userStore.currentUser.gender)

  const handleClose = () => {
    setSex(userStore.currentUser.gender)
    showVisible(false)
  }

  const handleSubmit = () => {
    if (sex === userStore.currentUser.gender) {
      handleClose()
      return
    }
    const data = { gender: sex }
    const evt = new Event<Partial<UserUpdateData>>(EventNames.USER_UPDATE, {
      ...data,
    })
    eventStore.publish(evt, { flags: FLAG_ACK })
    alertSuccess({ message: "修改成功" })
    showVisible(false)
  }

  if (!visible) return null

  return (
    <CurModal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={handleClose}
    >
      <CurModalBox>
        <BetweenFlex width="100%" padding="13px 16px">
          <Text weight={400} color="#aaaaaa" onClick={handleClose}>
            关闭
          </Text>
          <Text weight={600} fontSize={14}>
            请选择
          </Text>
          <Text weight={400} color="#07c160" onClick={handleSubmit}>
            确定
          </Text>
        </BetweenFlex>
        <ColumnFlex width="100%" padding="12px 0">
          <CurViewButton
            type="button"
            onClick={() => setSex(UserGender.MALE)}
            style={sex === UserGender.MALE ? { backgroundColor: "#EDF8FF" } : undefined}
          >
            <Text style={sex === UserGender.MALE ? { color: "#07c160" } : undefined}>男</Text>
          </CurViewButton>
          <CurViewButton
            type="button"
            onClick={() => setSex(UserGender.FEMALE)}
            style={sex === UserGender.FEMALE ? { backgroundColor: "#EDF8FF" } : undefined}
          >
            <Text style={sex === UserGender.FEMALE ? { color: "#07c160" } : undefined}>女</Text>
          </CurViewButton>
        </ColumnFlex>
      </CurModalBox>
    </CurModal>
  )
}

export default observer(Modal)
